export const SET_SELECTED_STATUS_ACTION = 'selectedStatus';

export const SET_SEARCH_TEXT_ACTION = 'searchText';
export const SET_TAGS_ACTION = 'tags';
export const SET_SHOW_COMISSAO_ACTION = 'showComissao';
